import { getUnixTime } from 'date-fns';
import api from 'src/utils/ajax';

import { Note } from './_types';
import { denormalizeNote, normalizeNote } from './normalizers';

export const fetchNotes = async ({
  userId,
  page = 1,
  perPage = 20,
  sort,
  sortDir,
  filters,
}) => {
  const response = await api.get(`/api/v4/user_notes`, {
    params: {
      page: page,
      per: perPage,
      user_id: userId,
      start_date: filters.startDate
        ? getUnixTime(new Date(filters.startDate))
        : null,
      end_date: filters.endDate
        ? getUnixTime(new Date(filters.endDate).setHours(23, 59, 59, 999))
        : null,
      q: {
        s: sort ? `${sort} ${sortDir}` : 'date desc',
        has_type: filters.types?.join(','),
      },
    },
  });

  const notes: Note[] = (response.data.user_note || response.data)?.map(
    (entry) => {
      const normalized = normalizeNote(entry);
      return normalized;
    }
  );

  if (!notes) {
    return { notes: [], total: 0 };
  }

  return {
    notes,
    total: response.data.meta.total,
  };
};

export const createNote = async (note: Partial<Note>) => {
  const response = await api.post(`/api/v4/user_notes`, denormalizeNote(note));
  return normalizeNote(response.data);
};

export const updateNote = async (note: Partial<Note>) => {
  const response = await api.put(
    `/api/v4/user_notes/${note.id}`,
    denormalizeNote(note)
  );
  return normalizeNote(response.data);
};

export const deleteNote = async (note: Partial<Note>) => {
  const response = await api.delete(`/api/v4/user_notes/${note.id}`);
  return normalizeNote(response.data);
};
